import { canCreateAnnouncementMessage, canCreateStandardMessage } from "@/helpers/permissions";
import type { PermissionSelector } from "@/hooks/usePermission";

export { canCreateAnnouncementMessage, canCreateStandardMessage };

export const canCreateMessage: PermissionSelector = (x) => x.canCreatePosts;

export const canPostInMarketplace: PermissionSelector = (x) => x.canPostInMarketplace;
